.root {
  margin-bottom: 20px; /* TODO: Add this to the app shell */

  td {
    text-align: center;
    min-width: 3em;
  }

  .year {
    width: 60px;
  }

  .year_count {
    font-size: 0.8em;
    font-weight: normal;
  }

  td.taxon_cell {
    text-align: left;
    padding-left: 5px;
    padding-right: 5px;
  }
}
